'use client';

import {
  CommonDialogLayout,
  Dialog,
  createPortableDialog,
  usePortableDialog,
} from '@wwe-portal/ui/components/dialog';
import { Button } from '@wwe-portal/ui/components/button';
import { useTranslations } from 'next-intl';

export interface OtoCloseConfirmDialogProps {
  onConfirm: () => void;
  onCancel?: () => void;
}

export const OtoCloseConfirmDialog = createPortableDialog(
  ({ onConfirm, onCancel }: OtoCloseConfirmDialogProps) => {
    const t = useTranslations();
    const modal = usePortableDialog();

    const handleCancel = () => {
      modal.remove();
      onCancel?.();
    };

    const handleConfirm = () => {
      modal.remove();
      onConfirm();
    };

    return (
      <Dialog
        open={modal.visible}
        onOpenChange={(isOpen) => {
          if (!isOpen) handleCancel();
        }}
      >
        <CommonDialogLayout
          imageElement={null}
          titleElement={t('oto_close_confirm_title')}
          descriptionElement={
            <span className="text-base">
              {t('oto_close_confirm_description')}
            </span>
          }
          onClose={handleCancel}
          actionElement={
            <div className="flex gap-5">
              <Button
                onClick={handleConfirm}
                variant="secondary"
                size="large"
                className="bg-borderColor1 hover:text-inlineTextColor6 text-text500 min-h-[50px] min-w-[110px] text-sm font-light uppercase"
              >
                {t('oto_close_confirm_close')}
              </Button>
              <Button
                variant="blue"
                size="large"
                onClick={handleCancel}
                className="min-h-[50px] min-w-[110px] text-sm font-light uppercase"
              >
                {t('oto_close_confirm_keep')}
              </Button>
            </div>
          }
          closable={true}
          dataId="oto-close-confirm-dialog"
        />
      </Dialog>
    );
  }
);
